import React from "react"
import { useEffect, useState } from "react"
import { Link } from "gatsby"
import Weather from "../components/weather"
import Banner from "./banner"

export default function Header({ sticky, enquire, bannerBorder, horizon, light, title, lightBorder = false, subtitle, hideBanner = false, homepage = false }) {
    const border = sticky ? (lightBorder ? "" : "dark") : ""
    const [search, setSearch] = useState('')
    useEffect(() => {
        setSearch(window.location.search)
    }, [])
    return (
        <header className={`masthead ${homepage ? "homepage" : ""} ${border}`}>
            {!sticky && !hideBanner && <Banner bannerBorder={bannerBorder} title={title} subtitle={subtitle} light={!homepage && light} />}

            <div className={`header-grid ${homepage ? "bb1" : "bb1"} ${border}`}>
                <div className='m-hide flex align-center'>
                    <div className={`w-max h-100 py20 px40 ${homepage ? "br1" : "br1"} ${border} flex align-center`}>
                        <div className='mta mba'>
                            <Weather />
                        </div>
                    </div>
                </div>
                <a href={`/${search}`} className='link py20 px40'>
                    <div className={"logo--main " + (horizon ? "horizon" : "")} />
                </a>
                <div className='mla flex '>
                    <div className={`text-right py20 px40 h-100 flex align-center mta mba ${homepage ? "bl1" : "bl1"} ${border} w-max`}>
                        <a href={`/enquiry${search}`} className='sm-copy'>Enquire</a>
                    </div>
                </div>
            </div>
        </header>
    )
}
